export function Footer() {
    return (
        <footer className="border-t border-slate-200 bg-slate-50">
            <div className="mx-auto max-w-6xl px-6 py-8 text-sm text-slate-600">
                <div>&copy; {new Date().getFullYear()} Protomation</div>
                <div className="mt-3 text-xs text-slate-500">
                    Protomation is a business name of Flahive Precision Engineering Pty Ltd
                </div>
                <div className="mt-1 text-xs text-slate-500">ABN: 62 625 356 505</div>
                <div className="text-xs text-slate-500">ACN: 625 356 505</div>
            </div>
        </footer>
    );
}
